import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zr87no4yn6: FaireBrandEntity = {
  token: "b_zr87no4yn6",
  type: "brand",
  name: "Elijah's Xtreme Gourmet Sauces",
  avatarUrl:
    "https://cdn.faire.com/fastly/407364516d4674e26cd3670ef3b0f0e8cccc2f6b13811c2f497a4e67e1c810da.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d1fd46b9dad249e8fd68d49733a5f78ac4fef70ea849757188f5814ff1542e7c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/407364516d4674e26cd3670ef3b0f0e8cccc2f6b13811c2f497a4e67e1c810da.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d1fd46b9dad249e8fd68d49733a5f78ac4fef70ea849757188f5814ff1542e7c.jpeg",
  location: "Gastonia, NC, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 35,
  isInsider: true,
  description:
    'Elijah’s Xtreme® was created from a father and son’s love of hot peppers and passion to create a more flavorful, thicker, hotter, hot sauce. Elijah’s Xtreme Ghost Pepper Sauce officially launched in June of 2014! In August they landed their first account – Bass Pro Shops nationwide. Elijah’s Xtreme has been a top seller at Bass Pro ever since!\n\nThe inspiration for the business came from Elijah in 2003 at the age of 6, in his fathers garden. He asked what he could do to be the youngest person to eat the world\'s hottest pepper. At that his father Bret, gave him a hot banana pepper and said "Start here.". That first bite sent Elijah running for water and began his love for hot peppers and hot sauces.\n\n10 years later our father and son owned and operated company has 9 different sauces ranging from mild Pineapple-Mango Habanero to Carolina Reaper Infused Hot Honey, and up to super hot Xtreme Regret Reserve! Handcrafted recipes we made to have the perfect blend of heat AND flavor. From this desire our sauces have won over 60 industry awards (and counting). ',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:52:09.010Z",
    importedBy: "entity-db-cli",
  },
};
